module.exports = __webpack_public_path__ + "img/result_wine_e.8025efe3.png";